import type EnType from '../en-US/response';

export default {
  'response.responseDefinitionWasDeleted':
    'A definição de resposta foi excluída, por favor tente outra.',
  'response.responseIsNotJson': 'O formato dos dados de resposta não é JSON.',
  'response.responseIsNotMsgpack': 'O formato dos dados de resposta não é Msgpack.',
  'response.responseIsNotNoContent': 'Esta resposta não deve ter um corpo.',
  'response.resultResponseWithDetail': 'retornou {response}, esperado {responseDefinition}.',
  'response.responseSizeThreshold':
    'se o tamanho dos dados for maior que 50MB, a resposta não será mostrada.',
  'response.imageContentType': 'Imagem: {type}',
  'response.fileContentType': 'Arquivo: {type}',
  'response.pdfContentType': 'PDF: {type}',
  'response.videoContentType': 'Vídeo: {type}',
  'response.tooManyCharacters':
    'Por motivos de desempenho, o conteúdo da resposta não está formatado.',
  'response.saveAsFile': 'Salvar como arquivo',
} satisfies typeof EnType;
